import { HolisFile } from 'src/app/common/models/hol-attachments.model';
import { HolisLink } from '../../models/hol-attachments.model';
import { ConfirmationModalComponent } from 'src/app/common/modals/confirmation-modal/confirmation-modal.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FileUploadAttachmentModalComponent } from '../file-upload-attachment-modal/file-upload-attachment-modal.component';
import { HolAttachments } from '../../models/hol-attachments.model';
import { HolFlight } from '../../models/hol-flight.model';
import { getFileIconOrImage, getFileType, TypeFile } from '../../utils/files-utils';
import { TranslateService } from '@ngx-translate/core';
import { EditionTitleDocumentModalComponent } from '../edition-title-document-modal/edition-title-document-modal.component';
import { HoleFilesData } from '../../models/hol-file-data';

@Component({
  selector: 'app-file-and-image-upload',
  templateUrl: './file-and-image-upload.component.html',
  styleUrls: ['./file-and-image-upload.component.scss'],
})
export class FileAndImageUploadComponent implements OnInit {
  @Input()
  public attachments: HolAttachments;
  @Input()
  public column: boolean;
  @Input()
  public disabled: boolean;
  @Input()
  public hideImage: boolean;
  @Input()
  public hideFile: boolean;
  @Input()
  public hideLink: boolean;
  @Input()
  public hideNote: boolean;
  @Input()
  public hideButtonTitle: boolean;
  @Input()
  public hideNotePreview: boolean;
  @Input()
  public multipleFileEnabled: boolean;

  @Input()
  public context: {
    module: string;
    category: string;
    htmlTitle: string;
    htmlScenario?: string;
    htmlDate;
    htmlNextInfo?;
    htmlTemplate: string;
    flight?: HolFlight;
    task?: any;
    initLabelName?: string;
  };

  @Input()
  public isPdf = false;
  @Output()
  public onAttachmentUpdated: EventEmitter<any> = new EventEmitter();
  public myFiles: HoleFilesData[] = [];
  protected readonly TypeFile = TypeFile;

  public uploading = false;
  @Input() required = false;

  constructor(public dialog: MatDialog, private translate: TranslateService) {}

  ngOnInit(): void {
    this.attachments = this.attachments || new HolAttachments();

    this.loadAndPrepareDisplay();
  }

  openAttachmentModal(type): void {
    let newObject;
    if (!this.attachments[type]) {
      newObject = type === 'link' ? new HolisLink() : new HolisFile();
    }

    const dialogRef: MatDialogRef<FileUploadAttachmentModalComponent> = this.dialog.open(FileUploadAttachmentModalComponent, {
      data: {
        context: this.context,
        attachment: this.attachments[type] || newObject,
        isOnDashboard: this.context.task ? this.context.task.isOnDashboard : false,
        type,
        displayImageTab: !this.attachments.image,
        displayLinkTab: !this.attachments.link,
      },
    });
    dialogRef.componentInstance.uploadingState.subscribe((uploading: boolean) => {
      this.uploading = uploading;
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.attachment) {
        if (result.type === 'link') {
          this.onLinkAdded(result.attachment);
        } else {
          if (result.attachment.uploadedUrl) {
            if (result.type === 'image') {
              this.onUploadImageSuccess(result.attachment);
            } else if (result.type === 'file') {
              this.onUploadFileSuccess(result.attachment);
            } else if (result.type === 'files') {
              this.onUploadFilesSuccess(result.attachment);
            }
          }
        }
        this.loadAndPrepareDisplay();
      }
    });
  }

  onUploadFileSuccess($event): void {
    this.attachments.file = {
      title: $event.title,
      fileName: $event.fileName,
      url: $event.uploadedUrl,
    };
    this.onAttachmentUpdated.emit();
  }

  onUploadFilesSuccess($event): void {
    const file = {
      title: $event.title,
      fileName: $event.fileName,
      url: $event.uploadedUrl,
    };
    if (!this.attachments.files) {
      this.attachments.files = [];
    }

    this.attachments.files.push(file);

    this.onAttachmentUpdated.emit();
  }

  onNoteAdded($event: { note: any; file: any }): void {
    this.attachments.note = $event.note;
    this.attachments.noteFile = {
      fileName: $event && $event.file ? $event.file.fileName : '',
      url: $event && $event.file ? $event.file.url : '',
    };
    this.onAttachmentUpdated.emit();
  }

  onUploadImageSuccess($event): void {
    this.attachments.image = {
      title: $event.title,
      fileName: $event.fileName,
      url: $event.uploadedUrl,
    };

    this.onAttachmentUpdated.emit();
  }

  onLinkAdded($event): void {
    this.attachments.link = $event;
    this.onAttachmentUpdated.emit();
  }

  removeFile(event): void {
    event.stopPropagation();

    this.dialog
      .open(ConfirmationModalComponent, {
        data: {
          modalTitle: this.translate.instant('COMMON.MODALS.CONFIRMATION.DELETE_FILE_TITLE'),
          modalContent: this.translate.instant('COMMON.MODALS.CONFIRMATION.DELETE_FILE_CONTENT'),
          modalQuestion: this.translate.instant('COMMON.MODALS.CONFIRMATION.QUESTION'),
        },
      })
      .afterClosed()
      .toPromise()
      .then(confirm => {
        if (confirm) {
          this.attachments.file = undefined;
          this.onAttachmentUpdated.emit();
          this.loadAndPrepareDisplay();
        }
      });
  }

  removeFiles(event, index): void {
    event.stopPropagation();

    this.dialog
      .open(ConfirmationModalComponent, {
        data: {
          modalTitle: this.translate.instant('COMMON.MODALS.CONFIRMATION.DELETE_FILE_TITLE'),
          modalContent: this.translate.instant('COMMON.MODALS.CONFIRMATION.DELETE_FILE_CONTENT'),
          modalQuestion: this.translate.instant('COMMON.MODALS.CONFIRMATION.QUESTION'),
        },
      })
      .afterClosed()
      .toPromise()
      .then(confirm => {
        if (confirm) {
          if (index > -1) {
            this.attachments.files.splice(index, 1);
          }
          this.onAttachmentUpdated.emit();
          this.loadAndPrepareDisplay();
        }
      });
  }

  removeImage(event): void {
    event.stopPropagation();

    this.dialog
      .open(ConfirmationModalComponent, {
        data: {
          modalTitle: this.translate.instant('COMMON.MODALS.CONFIRMATION.DELETE_IMAGE_TITLE'),
          modalContent: this.translate.instant('COMMON.MODALS.CONFIRMATION.DELETE_IMAGE_CONTENT'),
          modalQuestion: this.translate.instant('COMMON.MODALS.CONFIRMATION.QUESTION'),
        },
      })
      .afterClosed()
      .toPromise()
      .then(confirm => {
        if (confirm) {
          this.attachments.image = undefined;
          this.onAttachmentUpdated.emit();
          this.loadAndPrepareDisplay();
        }
      });
  }

  removeNote(event): void {
    event.stopPropagation();

    this.dialog
      .open(ConfirmationModalComponent, {
        data: {
          modalTitle: this.translate.instant('COMMON.MODALS.CONFIRMATION.NOTE_TITLE'),
          modalContent: this.translate.instant('COMMON.MODALS.CONFIRMATION.NOTE_CONTENT'),
          modalQuestion: this.translate.instant('COMMON.MODALS.CONFIRMATION.QUESTION'),
        },
      })
      .afterClosed()
      .toPromise()
      .then(confirm => {
        if (confirm) {
          this.attachments.note = undefined;
          this.attachments.noteFile = undefined;
          this.onAttachmentUpdated.emit();
          this.loadAndPrepareDisplay();
        }
      });
  }

  removeLink(event): void {
    event.stopPropagation();

    this.dialog
      .open(ConfirmationModalComponent, {
        data: {
          modalTitle: this.translate.instant('COMMON.MODALS.CONFIRMATION.DELETE_LINK_TITLE'),
          modalContent: this.translate.instant('COMMON.MODALS.CONFIRMATION.DELETE_LINK_CONTENT'),
          modalQuestion: this.translate.instant('COMMON.MODALS.CONFIRMATION.QUESTION'),
        },
      })
      .afterClosed()
      .toPromise()
      .then(confirm => {
        if (confirm) {
          this.attachments.link = undefined;
          this.onAttachmentUpdated.emit();
          this.loadAndPrepareDisplay();
        }
      });
  }

  public removeHolFilesData(event: MouseEvent, holFileData: HoleFilesData): void {
    if (holFileData.source === 'file') {
      this.removeFile(event);
    } else if (holFileData.source === 'files') {
      this.removeFiles(event, holFileData.index);
    } else if (holFileData.source === 'image') {
      this.removeImage(event);
    } else if (holFileData.source === 'link') {
      this.removeLink(event);
    }
  }

  public editHolFilesTitle(event: MouseEvent, holFileData: HoleFilesData): void {
    event.stopPropagation();

    const dialogRef: MatDialogRef<EditionTitleDocumentModalComponent> = this.dialog.open(EditionTitleDocumentModalComponent, {
      data: {
        title: holFileData.title,
        fileName: holFileData.fileName,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.title !== holFileData.title) {
        holFileData.title = result.title;
        switch (holFileData.source) {
          case 'link':
            this.attachments.link.title = result.title;
            break;
          case 'file':
            this.attachments.file.title = result.title;
            break;
          case 'files':
            this.attachments.files[holFileData.index].title = result.title;
            break;
          case 'image':
            this.attachments.image.title = result.title;
            break;
        }
        this.onAttachmentUpdated.emit();
      }
    });
  }

  openFile(url: string): void {
    window.open(url, '_blank');
  }

  private loadAndPrepareDisplay(): void {
    this.myFiles = [];
    if (this.attachments.file) {
      const type: TypeFile = getFileType(this.attachments.file.url);
      this.myFiles.push({
        fileName: this.attachments.file.fileName,
        url: this.attachments.file.url,
        type: type,
        title: this.attachments.file.title,
        canBeDeleted: this.attachments.file.canBeDeleted,
        urlImage: 'assets/images/attachment/other.png',
        source: 'file',
      });
    }
    if (this.attachments.image) {
      this.myFiles.push({
        fileName: this.attachments.image.fileName,
        url: this.attachments.image.url,
        type: TypeFile.image,
        title: this.attachments.image.title,
        canBeDeleted: this.attachments.image.canBeDeleted,
        urlImage: this.attachments.image.url,
        source: 'image',
      });
    }
    if (this.attachments.files) {
      this.attachments.files.forEach((file: HolisFile, index: number): void => {
        const type: TypeFile = getFileType(file.url);
        const urlImage = getFileIconOrImage(type, file);

        this.myFiles.push({
          fileName: file.fileName,
          url: file.url,
          type: type,
          title: file.title,
          canBeDeleted: file.canBeDeleted,
          urlImage: urlImage,
          index: index,
          source: 'files',
        });
      });
    }
    if (this.attachments.link) {
      this.myFiles.push({
        fileName: this.attachments.link.url,
        url: this.attachments.link.url,
        type: TypeFile.url,
        title: this.attachments.link.title,
        canBeDeleted: true,
        urlImage: 'assets/images/attachment/url.png',
        source: 'link',
      });
    }
  }
}
